import {styled} from '../../styled-components';

interface Props {
    transparent?: boolean;
}

export const BackdropStyle = styled.div<Props>`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${props => (props.transparent ? 'transparent' : 'rgba(0,0,0,0.5)')};
    z-index: -1;
`;

BackdropStyle.displayName = 'BackdropStyle';
